export interface DashboardRequest {
  period?: DashboardPeriod;
}

export enum DashboardPeriod {
  today = 0,
  yesterday = 1,
  thisWeek = 2,
}
